"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transaction = void 0;
var Crypto_1 = require("../crypto/Crypto");
var PublicKeyAccount_1 = require("../account/PublicKeyAccount");
var BlockChain_1 = require("../BlockChain");
var DataWriter_1 = require("../DataWriter");
var Bytes_1 = require("../Bytes");
var AppCrypt_1 = require("../../../crypt/AppCrypt");
var BigDecimal_1 = require("../../BigDecimal");
var Transaction = /** @class */ (function () {
    function Transaction(typeBytes, typeName, creator, feePow, timestamp, reference, port, genesis_sign) {
        this.typeBytes = typeBytes;
        this.port = port;
        this.creator = creator;
        //this.props = props;
        this.timestamp = timestamp;
        this.reference = reference;
        this.genesis_sign = genesis_sign;
        if (feePow < 0) {
            feePow = 0;
        }
        else if (feePow > BlockChain_1.BlockChain.FEE_POW_MAX) {
            feePow = BlockChain_1.BlockChain.FEE_POW_MAX;
        }
        this.feePow = feePow;
    }
    Transaction.diffScale = function (v) {
        var n = new BigDecimal_1.BigDecimal(v);
        var diffScale = n.getScale() - Transaction.AMOUNT_DEFAULT_SCALE;
        if (diffScale !== 0) {
            if (diffScale < 0) {
                diffScale += Transaction.SCALE_MASK + 1;
            }
        }
        return diffScale;
    };
    Object.defineProperty(Transaction.prototype, "Signature", {
        get: function () {
            return this.signature;
        },
        enumerable: false,
        configurable: true
    });
    Transaction.prototype.sign = function (creator, asPack) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        _b = (_a = data).set;
                        return [4 /*yield*/, this.toBytes(false, null)];
                    case 1:
                        _b.apply(_a, [_e.sent()]);
                        if (!(this.genesis_sign.length > 0)) return [3 /*break*/, 2];
                        // sidechain mode
                        // console.log("transaction.sidechain");
                        data.set(this.genesis_sign);
                        return [3 /*break*/, 4];
                    case 2:
                        // all test a not valid for main test
                        // all other network must be invalid here!
                        //Если не ходят тразакции то возможно неверно указан порт. сейчас ок высчитывается при добавлении новой ноды как порт -1
                        // console.log("transaction.no_sidechain");
                        _d = (_c = data).set;
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray(this.port)];
                    case 3:
                        // all test a not valid for main test
                        // all other network must be invalid here!
                        //Если не ходят тразакции то возможно неверно указан порт. сейчас ок высчитывается при добавлении новой ноды как порт -1
                        // console.log("transaction.no_sidechain");
                        _d.apply(_c, [_e.sent()]);
                        _e.label = 4;
                    case 4:
                        this.signature = AppCrypt_1.AppCrypt.sign(data.data, creator.getSecretKey());
                        if (!!asPack) return [3 /*break*/, 6];
                        // need for recalc! if not as a pack
                        return [4 /*yield*/, this.calcFee()];
                    case 5:
                        // need for recalc! if not as a pack
                        _e.sent();
                        _e.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Transaction.prototype.toBytes = function (withSign, releaserReference) {
        return __awaiter(this, void 0, void 0, function () {
            var asPack, data, timestampBytes, referenceBytes, _a, _b, feePowBytes;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        asPack = releaserReference != null;
                        data = new DataWriter_1.DataWriter();
                        //WRITE TYPE
                        data.set(this.typeBytes);
                        if (!!asPack) return [3 /*break*/, 2];
                        return [4 /*yield*/, Bytes_1.Bytes.longToByteArray(this.timestamp)];
                    case 1:
                        timestampBytes = _c.sent();
                        //console.log({ timestamp: this.timestamp, timestampBytes, ts2: await Bytes.longFromByteArray(timestampBytes)});
                        timestampBytes = Bytes_1.Bytes.ensureCapacity(timestampBytes, Transaction.TIMESTAMP_LENGTH, 0);
                        data.set(timestampBytes);
                        _c.label = 2;
                    case 2:
                        if (!(this.reference != null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, Bytes_1.Bytes.longToByteArray(this.reference)];
                    case 3:
                        referenceBytes = _c.sent();
                        referenceBytes = Bytes_1.Bytes.ensureCapacity(referenceBytes, Transaction.REFERENCE_LENGTH, 0);
                        data.set(referenceBytes);
                        _c.label = 4;
                    case 4:
                        //WRITE CREATOR
                        _b = (_a = data).set;
                        return [4 /*yield*/, this.creator.getPublicKey().publicKey];
                    case 5:
                        //WRITE CREATOR
                        _b.apply(_a, [_c.sent()]);
                        //console.log("Transaction4",{ data });
                        //WRITE FEE POWER
                        if (!asPack) {
                            feePowBytes = new Int8Array([0]);
                            feePowBytes[0] = this.feePow;
                            data.set(feePowBytes);
                        }
                        //SIGNATURE
                        if (withSign) {
                            data.set(this.signature);
                            //console.log("Transaction6",{ data, signature: this.signature });
                        }
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    Transaction.prototype.calcBaseFee = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.calcCommonFee()];
            });
        });
    };
    Transaction.prototype.calcFee = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fee, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = BigDecimal_1.BigDecimal.bind;
                        return [4 /*yield*/, this.calcBaseFee()];
                    case 1:
                        fee = new (_a.apply(BigDecimal_1.BigDecimal, [void 0, _b.sent()]))().setScale(8, BigDecimal_1.BigDecimal.ROUND_UP);
                        if (this.feePow > 0) {
                            this.fee = fee
                                .multiply(new BigDecimal_1.BigDecimal(BlockChain_1.BlockChain.FEE_POW_BASE).pow(this.feePow))
                                .setScale(8, BigDecimal_1.BigDecimal.ROUND_UP);
                        }
                        else {
                            this.fee = fee;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Transaction.prototype.calcCommonFee = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataLength(false)];
                    case 1: return [2 /*return*/, (_a.sent()) * BlockChain_1.BlockChain.FEE_PER_BYTE];
                }
            });
        });
    };
    Transaction.prototype.amountToBytes = function (n, dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var bytes, diffScale, num;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bytes = new Int8Array([]);
                        diffScale = n.getScale() - Transaction.AMOUNT_DEFAULT_SCALE;
                        if (diffScale !== 0) {
                            num = n.num * BigDecimal_1.BigDecimal.pow(10, diffScale);
                            if (diffScale < 0) {
                                diffScale += Transaction.SCALE_MASK + 1;
                            }
                            n = new BigDecimal_1.BigDecimal(num);
                        }
                        return [4 /*yield*/, Bytes_1.Bytes.longToByteArray(n.unscaledValue())];
                    case 1:
                        bytes = _a.sent();
                        bytes = Bytes_1.Bytes.ensureCapacity(bytes, Transaction.AMOUNT_LENGTH, 0);
                        dataWriter.set(bytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    Transaction.CERTIFY_PUB_KEYS_TRANSACTION = 36;
    Transaction.SIGNATURE_LENGTH = Crypto_1.CoreCrypto.SIGNATURE_LENGTH;
    Transaction.TIMESTAMP_LENGTH = 8;
    Transaction.REFERENCE_LENGTH = Transaction.TIMESTAMP_LENGTH;
    Transaction.ISSUE_PERSON_TRANSACTION = 24;
    Transaction.ISSUE_ASSET_TRANSACTION = 21;
    Transaction.SEND_ASSET_TRANSACTION = 31;
    Transaction.ORDER_TRANSACTION = 50;
    Transaction.UPDATE_ORDER_TRANSACTION = 52;
    Transaction.DOCUMENT_TRANSACTION = 35;
    Transaction.ORDER_TRANSACTION_CANCEL = 51;
    Transaction.KEY_LENGTH = 8;
    Transaction.AMOUNT_DEFAULT_SCALE = 8;
    Transaction.SCALE_MASK = 31;
    Transaction.AMOUNT_LENGTH = 8;
    Transaction.FEE_POWER_LENGTH = 1;
    Transaction.TYPE_LENGTH = 4;
    Transaction.CREATOR_LENGTH = PublicKeyAccount_1.PublicKeyAccount.PUBLIC_KEY_LENGTH;
    Transaction.BASE_LENGTH = Transaction.TYPE_LENGTH +
        Transaction.FEE_POWER_LENGTH +
        Transaction.REFERENCE_LENGTH +
        Transaction.TIMESTAMP_LENGTH +
        Transaction.CREATOR_LENGTH +
        Transaction.SIGNATURE_LENGTH;
    Transaction.BASE_LENGTH_AS_PACK = Transaction.TYPE_LENGTH + Transaction.CREATOR_LENGTH + Transaction.SIGNATURE_LENGTH;
    Transaction.IS_TEXT_LENGTH = 1;
    Transaction.ENCRYPTED_LENGTH = 1;
    Transaction.DATA_SIZE_LENGTH = 4;
    return Transaction;
}());
exports.Transaction = Transaction;
